import ServiceCRUD from '../../../../services/ServiceCRUDFLEXUC';

class CallbacksService extends ServiceCRUD {
  constructor() {
    super(`/api/callbacks`);
  }
}

export default new CallbacksService();
